import styled from '@emotion/styled';

import COLORS from '../../styles/emotion/colors3';
import ZINDEX from '../../styles/emotion/zIndex';

export const Overlay = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: ${ZINDEX.super};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalDialog = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  padding: 8px;
  margin: 100px;
  background-color: white;
`;

export const CloseModalButton = styled.button`
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  outline: none;
  border: none;
  background: none;
  color: var(--text-primary, ${COLORS.BLACK_100});
  &:hover {
    color: var(--text-secondary, ${COLORS.BLACK_075});
    cursor: pointer;
  }
  &:focus {
    outline: highlight auto 2px;
    outline: -webkit-focus-ring-color auto 2px;
  }
`;

export const ScreenReaderText = styled.span`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
